import { withBasePath } from "@/lib/portal/base-path";

/** Static brand assets under `public/abc-fitness/brand/`. */
export const ABC_FITNESS_BRAND_LOGO = "/abc-fitness/brand/logo.png";
/** Monogram alone, alpha-only so it can be tinted with a CSS mask. */
export const ABC_FITNESS_BRAND_MONOGRAM = "/abc-fitness/brand/monogram.png";

export function getAbcFitnessBrandLogoHref(): string {
  return withBasePath(ABC_FITNESS_BRAND_LOGO);
}

export function getAbcFitnessBrandMonogramHref(): string {
  return withBasePath(ABC_FITNESS_BRAND_MONOGRAM);
}
